<template>
  <vs-popup
    :title="'Edit section: ' + (section ? section.name : '')"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="edit-venue-section-popup"
  >
    <vs-tabs v-if="clonedSection">
      <vs-tab label="Section details">
        <vs-row vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx"
              label="Section name"
              placeholder="Example: 'Main floor'"
              v-model="clonedSection.name"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-2">
          <vs-col vs-w="12">
            <vs-input
              class="inputx"
              label="Section description"
              placeholder="Describe the section"
              v-model="clonedSection.description"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-2">
          <vs-col vs-w="12">
            <vs-input
              class="inputx"
              label="Section image"
              placeholder="Image url"
              v-model="clonedSection.image"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-4">
          <vs-col vs-w="12">
            <vs-checkbox
              class="ml-0"
              label="Can this section only be booked by request?"
              v-model="clonedSection.bookingOnRequestOnly"
              >Request only</vs-checkbox
            >
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-4" v-if="clonedSection.bookingOnRequestOnly">
          <vs-col vs-w="12">
            <vs-checkbox
              class="ml-0"
              label="Does request require budget?"
              v-model="clonedSection.bookingRequireBudget"
              >Require request budget</vs-checkbox
            >
          </vs-col>
        </vs-row>
      </vs-tab>

      <vs-tab label="Policies">
        <h6 class="mt-6 mb-4">Setup policies</h6>
        <edit-policies
          v-if="clonedSection"
          :object-with-policies="clonedSection"
          :policy-level="POLICY_LEVEL.Section"
        ></edit-policies>
      </vs-tab>
    </vs-tabs>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="warning"
        type="border"
        class="mr-4"

        @click="handleDeleteSection"
        >Delete Section</vs-button
      >
      <vs-button
        color="primary"
        :disabled="!(validForm && isDirty)"
        @click="handleSaveSectionClick"
        >Save Section</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import EditPolicies from "../components/policies/EditPolicies.vue";
import { POLICY_LEVEL } from '@/store/modules/marcom/data-model/policy-configurations/index.js';

export default {
  props: {
    setup: {
      type: Object
    }
  },
  components: { EditPolicies },
  data() {
    return {
      POLICY_LEVEL,
      section: undefined,
      clonedSection: undefined,
      showThisPopup: false,
    };
  },
  computed: {
    validForm() {
      return !!this.clonedSection && !!this.clonedSection.name && !!this.clonedSection.name.trim() && this.policiesValid;
    },
    isDirty() {
      return !_.isEqual(this.section, this.clonedSection);
    },
    policiesValid() {
      return !!this.clonedSection && this.clonedSection.venuePolicies.every(p => p.isValid());
    }
  },
  methods: {
    show(section) {
      this.section = section;

      if (!this.clonedSection) {
        this.clonedSection = _.cloneDeep(this.section);

        if (!this.clonedSection.venuePolicies) {
          this.clonedSection.venuePolicies = [];
        }
      }

      this.showThisPopup = true;
    },
    async handleSaveSectionClick() {
      this.$vs.loading();

      var sectionCommand = {
        venueSection: this.clonedSection,
        venueSetupId: this.setup.id,
      };

      try {
        var result = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.UpdateSection,
          sectionCommand
        );

        this.$vs.notify({
          color: "success",
          title: "Section saved",
          text: "Your section was saved",
        });

        this.handlePopupClose();

        this.$emit('section-saved', this.clonedSection);

      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Section saved",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async handleDeleteSection() {
       this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Delete section',
        text: 'Would you like to delete the section: ' + this.clonedSection.name + '?',
        acceptText: 'Delete section',
        accept:this.acceptAlertDeleteSection
      })
    },
    async acceptAlertDeleteSection() {

        this.$vs.loading();

        var deleteSectionCommand = {
          setupId: this.setup.id, sectionId: this.clonedSection.id,
        };

        try {
          var result = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.DeleteSection,
            deleteSectionCommand
          );

          //Update the client version
          //this.section.deleted = new Date().toString();
          this.handlePopupClose();

          this.$vs.notify({
            color: "success",
            title: "Section deleted",
            text: "Your section was deleted",
          });

          this.$emit('section-saved', this.clonedSection);
        }
        catch(err) {
          this.$vs.dialog({
            color: 'danger',
            title: 'Section was not deleted',
            text: "There are future bookings for this section: " + (err.details ? err.details : "") + (err.title ? err.title : "") + ", " + (err.detail ? err.detail : ""),
            acceptText: 'Ok',
          })
        }
        finally {
          this.$vs.loading.close();

        }
    },
    handlePopupClose() {
      this.clonedSection = undefined;
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-venue-section-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;

    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
